var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"radius-custom",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-4 pa-sm-6"},[_c('div',{staticClass:"s",domProps:{"innerHTML":_vm._s(_vm.wrapIframes(_vm.removeScripts(_vm.options.results, _vm.moduleId)))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }